import { constants } from "@/const"

export const sizeHelper = {
  data: () => ({
    smallSize: constants.SIZES.SMALL,
    mediumSize: constants.SIZES.MED,
    largeSize: constants.SIZES.LARGE
  })
}
